export const useGetEnvironment = () => {
  const environment = process.env.REACT_APP_ENVIRONMENT?.toUpperCase()

  const isDevelopment = environment === 'DEVELOPMENT'
  const isProduction = environment === 'PRODUCTION'
  const isHomologation = environment === 'HOMOLOGATION'

  return { isDevelopment, isHomologation, isProduction }
}
